import { useRouter } from "next/router";
import ImageWrapper from "../ImageComponent/ImageWrapper";

const HeroSection = () => {
  const router = useRouter();
  return (
    <div className="flex justify-center mt-8 sm:mt-12 md:mt-56">
      <div
        className={`${
          router.pathname === "/auth" || router.pathname === "/booking"
            ? "hidden"
            : "flex"
        } absolute -top-16 md:-top-40 -z-10`}
      >
        <div className=" flex justify-center w-full items-center">
          <ImageWrapper
            src="/icons/Group6473.svg"
            alt="Design image"
            width={680}
            className="object-cover"
          />
          <div className="flex absolute h-[40px] md:h-[74px]  w-full m-auto items-center justify-center">
            <ImageWrapper
              src="/icons/Group6935.svg"
              width={70}
              className="object-fit"
              title="Design image"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col justify-center">
      <div
  className={`md:mt-0 mt-28 md:flex flex-col items-center justify-center text-3xl leading-6 lg:text-5xl lg:leading-6 
    ${["/auth", "/user"].includes(router.pathname) || router.pathname.includes("/pooja") || router.pathname.includes("/category") ? "hidden" : ""} 
    md:my-8 xl:my-12 px-4 sm:px-6 w-full text-center`}
>
  <h1 className="text-HeaderQuote">
    India’s Most Trusted
  </h1>
  
  <p className="mt-8 text-HeaderQuote">
    <span className="text-Default md:inline-block whitespace-nowrap">
      Puja Services Platform! -2
    </span>
  </p>

  <p className="mt-12 text-HeaderQuote">
    <span className="text-Default block md:inline">
      9869 92 92 92
    </span>
  </p>
</div>


      </div>
    </div>
  );
};

export default HeroSection;
